import { getAuth } from "firebase/auth";
import {
  child, get, getDatabase, onValue, ref, update
} from "firebase/database";
import "../Firebase";

const auth = getAuth();

let db = getDatabase();
const dbRef = ref(getDatabase());
const teamsRef = ref(db, "teams");

export const getTeamList = async () => {
  let result = [];
  let teamsSnap = await get(teamsRef);
  let teams = teamsSnap.val();

  let companyUrlSnap = await get(ref(db, "companyUrl"));
  let companyUrls = companyUrlSnap.val();
  for (const team_id in teams) {
    if (Object.hasOwnProperty.call(teams, team_id)) {
      let team = teams[team_id];
      let teamMembers = team.members;
      let membersArr = [];
      for (const memberId in teamMembers) {
        if (Object.hasOwnProperty.call(teamMembers, memberId)) {
          let member = teamMembers[memberId];
          let usersRef = ref(db, `users/${memberId}`);
          onValue(usersRef, (userSnap) => {
            let user = userSnap.val();
            if (user) {
              member.name = user["username"];
              member.id = memberId;
              member.img = user.profile_picture;
            }
          });
          membersArr.push(member);
        }
      }
      for (const companyUrlKey in companyUrls) {
        if (companyUrls[companyUrlKey]["teamId"] === team_id) {
          team.companyUrl = companyUrls[companyUrlKey]["url"];
          break;
        }
      }
      team.id = team_id;
      team.members = membersArr;
      // if (team.companyUrl)
      result.push(team);
    }
  }
  return result;
};

export const vote = (teamId) => {
  get(child(teamsRef, `${teamId}`))
    .then((snapshot) => {
      if (!snapshot.exists()) {
        return false;
      }
      const uid = auth.currentUser.uid;
      let team = snapshot.val();
      if (team.likeBy) {
        if (team.likeBy.includes(uid)) {
          return false;
        }
        team.likeBy.push(uid);
        team.likes++;
      } else {
        team.likeBy = [auth.currentUser.uid];
        team.likes = 1;
      }
      update(ref(db, `teams/${teamId}`), {
        likeBy: team.likeBy,
        likes: team.likes,
      });
      return true;
    })
    .catch((err) => {
      console.log(err);
      return false;
    });
};

export const updateViewerCount = (teamId) => {
  get(child(teamsRef, `${teamId}`))
    .then((snapshot) => {
      if (!snapshot.exists()) {
        return false;
      }

      let team = snapshot.val();
      let ViewerCount = 0;
      if (team.ViewerCount) {
        ViewerCount = team.ViewerCount + 1;
      } else {
        ViewerCount = 1;
      }
      update(ref(db, `teams/${teamId}`), { ViewerCount: ViewerCount });
      return true;
    })
    .catch((err) => {
      console.log(err);
      return false;
    });
};
